import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnlocked: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="unlocked, unlock, private"><path d="M4.75 9.75H19.25V21.25H4.75V9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 9.5V7C7.75 4.65279 9.65279 2.75 12 2.75C14.3472 2.75 16.25 4.65279 16.25 7" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M12 14V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconUnlocked;
